export default function ingredientsModule() {
  const button = jQuery('.app-header-bottom > button');
  const nav = jQuery('.app-header-bottom > nav');
  button.click(() => nav.toggleClass('hidden'));
  nav.click(() => nav.addClass('hidden'));
}



// WEBPACK FOOTER //
// ./scripts/modules/menu.js